// NavList 파일
import superadmin_nav from './ListSuperAdmin';
import admin_nav from './ListAdmin';
import user_nav from './ListUser';
import all_nav from './ListAll';
import { PERMISSIONS } from 'store/baseConfig';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    [PERMISSIONS.SUPER_ADMIN] : superadmin_nav,
    [PERMISSIONS.ADMIN]: admin_nav,
    [PERMISSIONS.USER]: user_nav,
    [PERMISSIONS.ALL]: all_nav
};

export default menuItems;
